<template>

    <!-- ---------------------------------------------------------- -->
    <!-- ------------------- Instructions ------------------------- -->
    <!-- ---------------------------------------------------------- -->

    <div class="contentDiv">

        <div class="cardNew divMainPadding">

            <!-- ---------------- instructions --------------------- -->

            <div class="header-secondary" style="margin-bottom: 10px;">
                Instructions
            </div>

            <!-- ---------------- actions --------------------- -->

            <div class="leftJustify divContentPadding"><b>Please Note:</b> When individuals are moved from one contract
                to another, the following items actions will be taken:
            </div>


            <div class="leftJustify selectCursor divContentPadding" style="margin-bottom: 10px; margin-left: 30px;"
            @click="handleToggleInstructions">
                <span v-if="!showInstrutions" class="expandContractPlus">+</span>
                <span v-if="showInstrutions" class="expandContractMinus">-</span>
                <span v-if="!showInstrutions"><b>(Show instuctions)</b></span>
                <span v-if="showInstrutions"><b>(Hide instuctions)</b></span>
            </div>

            <!-- ---------------- list --------------------- -->

            <div v-if="showInstrutions">

                <ul style="margin-left: 25px;">
                    <li class="liStyle">The existing SPOT/DTS(LOA) will be changed to "LOA Needed".</li>
                    <li class="liStyle">The existing Deployment Start and End dates will be removed.</li>
                    <li class="liStyle">The existing AAL Number and Expiration date will be removed.</li>
                    <li class="liStyle">The existing Weapons Qualification information will be removed.</li>
                    <li class="liStyle">The existing Security Type will be removed.</li>
                    <li class="liStyle">The existing Employer will be removed.</li>
                    <li class="liStyle">The most recent version of each document type uploaded will be available.</li>
                    <li class="liStyle">The existing status will be set to "New".</li>
                </ul>

                <div style="text-align: left; padding-bottom: 30px; margin-left: 15px; margin-right: 15px;">
                    <div style="margin: 0px;">
                        <b>Transfers:</b> To transfer these individuals to another contract,
                        select the new contract from the dropdown list below.
                    </div>
                    <div style="margin: 0px;">Click on the <b>Transfer Record button</b> button make the transfers. 
                        <span style="color: darkred"><b>Note this action is irreversible.</b></span>
                    </div>
                </div>

            </div>

        </div>

    </div>

    <!-- ---------------------------------------------------------- -->
    <!-- ------------------- Data Grid ---------------------------- -->
    <!-- ---------------------------------------------------------- -->

    <!-- style="padding: 20px; width: 100%; min-width: 1150px;"> -->

    <div class="contentDiv cardUpperMargin">

        <div class="cardNew divMainPadding cardSeparation" 
            style="padding: 20px; width: 100%; min-width: 1150px;">

            <!-- ---------------- instructions --------------------- -->

            <div class="header-secondary" style="margin-bottom: 10px;">
                Select People to Transfer ( 
                <span style="font-style:italic"> 
                    <span style="color: #ffa500; font-size: larger;">
                        {{ numberOfSelectedPeople }}
                    </span>
                    Selected)
                </span>
            </div>

            <div class="instructionsLeft" style="margin-left: 15px; 
                                                    margin-right: 15px; 
                                                    margin-top: 15px; 
                                                    margin-bottom: 5px;">
                <b>Instructions:</b> To select individuals for transfer, 
                check the associated <b>Transfer</b> checkboxes.
            </div>

            <div class="leftJustify selectCursor divContentPadding" 
                style="margin-bottom: 10px; 
                margin-left: 30px;"
                @click="handleToggleSelGrid">

                <span v-if="!showSelGrid" class="expandContractPlus">+</span>
                <span v-if="showSelGrid" class="expandContractMinus">-</span>
                <span v-if="!showSelGrid"><b>(Show Selection Grid)</b></span>
                <span v-if="showSelGrid"><b>(Hide Selection Grid)</b></span>

            </div>

            <div  v-show="showSelGrid" class="instructionsLeft" style="margin-left: 60px; margin-bottom: 15px;">
                <button @click="handleSelectAllPeople" 
                        class="allButtons btn-primary" 
                        type="button">
                    Select All People
                </button>
                
                <button @click="handleClearAllPeople" 
                        class="allButtons btn-primary" 
                        type="button">
                    Clear All People
                </button>
            </div>

            <div v-show="showSelGrid">
                
                <ApplicationGrid 
                    :GridData="gridTime" 
                    :EnablePaging="true" 
                    :EnableSearching="true" 
                    :EnableSorting="true"
                    :HeaderArrays="headerArrays" 
                    :LeftRightSlots="leftRightSlots"                        
                    :RowsPerPageArray="rowsPerPageArray" 
                    :EnableSettings="true"
                    :EnableRecordsInfoDisplay="true">

                    <!-- ------------------------------------------------------------------------------- -->
                    <!-- -------------- Checkbox Template: (rightHeader10/rightData10) ----------------- -->
                    <!-- ------------------------------------------------------------------------------- -->
            
                    <template v-slot:rightHeader10>
                    <span>Transfer</span>
                    </template>
            
                    <template v-slot:rightData10="slotArgs">
            
                    <div class="transferDiv" 
                        :id="'personID_' + slotArgs.itemArg['personID']"
                        data-tooltip="tooltip" 
                        title="Check to select individual for transfer">
            
                        <input type="checkbox" 
                            :id="'checkBoxID_' + slotArgs.itemArg['personID']"
                            :checked="slotArgs.itemArg['selectedForTransfer']"
                            @click="handleCheckboxClick(slotArgs)" aria-label="Check the box to select the individual for transfer">
            
                    </div>
            
                    </template>

                </ApplicationGrid>
            </div>

        </div>

    </div>

    <!-- ---------------------------------------------------------- -->
    <!-- ------------------- Transfer Confirmation ---------------- -->
    <!-- ---------------------------------------------------------- -->

    <div class="contentDiv cardUpperMargin" v-if="showConfirmation">

        <div class="cardNew divMainPadding cardSeparation">
            <div class="container">

                <div class="instructionsLeft" style="margin-top: 15px">
                    <div class="header-secondary">Transfer Confirmation</div>
                </div>

                <div class="instructionsLeft" style="margin-left: 15px; margin-right: 15px; margin-top: 8px; margin-bottom: 0px; padding: 0px;">

                    <span style="font-weight: bold; color: darkred;">The transfer was accomplished Successfully:</span>

                    <div style="margin-top: 8px; margin-bottom: 0px; padding: 0px;">

                        <ul style="padding-top: 0px; padding-bottom: 0px; margin-top: 0px; margin-bottom: 0px;">
                            <li style="padding-top: 0px; padding-bottom: 0px; margin-top: 0px; margin-bottom: 0px;">
                            From: <span style="font-size: larger;"><b>{{ previousContractNumberForVerification }}</b></span> 
                            To: <span style="font-size: larger;"><b>{{ selectedContractNumber }}</b></span>
                            </li>
                            <ul>
                                <li>Number of People Transfered: 
                                    <span style="font-size: larger;"><b>{{ confirmedNumberTransferred }}</b></span> 
                                </li>
                            </ul>
                        </ul>

                        <div class="leftJustify selectCursor divContentPadding" 
                            style="margin-bottom: 5px; 
                            margin-left: 4px;"
                            @click="handleToggleSelPeopleNames">

                            <span v-if="!showConfirmSelectedNames" class="expandContractPlus">+</span>
                            <span v-if="showConfirmSelectedNames" class="expandContractMinus">-</span>
                            <span v-if="!showConfirmSelectedNames"><b>(Show Selected People)</b></span>
                            <span v-if="showConfirmSelectedNames"><b>(Hide Selected People)</b></span>
                        </div>
                        <ul v-if="showConfirmSelectedNames" 
                            v-for="item in selectedPeopleNamesArray"
                            :key="item"
                            style="padding: 0px; margin-left: 35px; margin-top: 0px; margin-bottom: 0px;">
                            <li style="margin-left: 35px; margin-top: 0px;">
                                <span style="font-weight: bold; color: darkblue;">{{ item }}</span>
                            </li>
                        </ul>

                    </div>
                </div>

                <hr style="margin-top: 10px; margin-bottom: 0px;" />

                <div style="margin-bottom: 10px; margin-top: 10px;">
                    <button @click="handleHideConfirmationClick" 
                            class="allButtons btn-primary" 
                            type="button"> 
                    Hide</button>
                </div>

            </div>
        </div>

    </div>

    <!-- ---------------------------------------------------------- -->
    <!-- ------------------- Transfer ----------------------------- -->
    <!-- ---------------------------------------------------------- -->

    <div class="contentDiv cardUpperMargin">

        <div class="cardNew divMainPadding cardSeparation">

            <div class="header-secondary" style="margin-bottom: 10px; padding-left: 25px; padding-right: 25px;">
                Person Contract Transfer ( 
                <span style="font-style:italic"> 
                    <span style="color: #ffa500; font-size: larger;">
                        {{ numberOfSelectedPeople }}
                    </span>
                    Selected)
                </span>
            </div>

            <div class="instructionsLeft" style="margin-top: 10px;">
                <div style="margin-left: 15px; margin-right: 15px; margin-top: 10px; margin-bottom: 5px; text-align: center;">
                    <div style="display: inline-block; margin-left: 15px;">
                        <b>Current Contract: </b> 
                        <span style="color: darkred; font-weight: bold;">{{ contractNumber }} </span>
                        
                    </div>
                </div>
            </div>

            <div style="margin-top: 10px;"><b>Transfer To:</b>

                <select id="ddlContractID" 
                    @change="setSubmitDisableValue"  aria-label="Select contract number from the dropdown list"
                    v-model="selectedContractID" class="ctrlBorderRadius ctrlDropDown ctrlDropDownMargin">
                    <option v-for="item in contractList" 
                            :value="item.contractId" 
                            :key="item.contractId">
                        {{ item.contractNumber }}
                    </option>
                </select>

            </div>

            <hr style="margin-top: 10px; margin-bottom: 10px;" />

            <div style="margin-bottom: 10px; margin-top: 0px;">

                <button @click="handleBackClick" 
                        class="allButtons btn-primary" 
                        type="button">
                    Back to Previous Page
                </button>

                <button v-if="disableSubmit || (numberOfSelectedPeople == 0)" 
                    id="submitBtnID" 
                    class="allButtonsDisabled" 
                    style="margin-left: 15px; cursor: default;"
                    disabled
                    type="button">
                    Transfer Record (diabled)
                </button>

                <button v-else
                    id="submitBtnID" 
                    @click="handleTransferClick" 
                    class="allButtons btn-primary" 
                    style="margin-left: 15px;"
                    type="button">
                    Transfer Record
                </button>

            </div>

        </div>

    </div>

    <!-- ----------------------------------------------------------------------------- -->
    <!-- --------------------------- Transfer Warning Popup -------------------------- -->
    <!-- ------------------------------------------------------------------------------ -->

    <div id="xmodal-main-ID" class="xmodal-container-main">
        <div class="xmodal-container-content">

        <!-- ---------------------------------------------------------------- -->
        <!-- --------------------------- HEADER ----------------------------- -->
        <!-- ---------------------------------------------------------------- -->

        <div class="header-primary">{{ modalTitle }}</div>

        <hr class="xmodal-hr-top" />

        <!-- ---------------------------------------------------------------- -->
        <!-- --------------------------- FORM ------------------------------- -->
        <!-- ---------------------------------------------------------------- -->

        <div class="xmodal-container-form">
            <div>Are you sure you want to transfer to a new contract
            (This action is <span style="color: darkred; margin-left: 5px;"><b>irreversible</b></span>)?
            </div>
        </div>

        <hr class="xmodal-hr-bottom" />

        <!-- ---------------------------------------------------------------- -->
        <!-- --------------------------- Footer ----------------------------- -->
        <!-- ---------------------------------------------------------------- -->

        <div class="xmodal-footer">
            <button type="button" @click="handleCancelTransferClick"
            class="allButtons btn-danger">
            No - Cancel Transfer
            </button>
            <button id="xmodal-submit-btn-id" type="button" 
            @click="handleDatabaseTransferSubmitClick"
            class="allButtons  btn-primary"
            style="margin-left: 15px;">
            Yes - Submit Transfer
            </button>
        </div>
        </div>
    </div>
  
</template>

<script>
import axios from "axios";
import { store } from "../../store/store.js";
import ApplicationGrid from "../../components/dataSupport/ApplicationGrid.vue";

export default {
    data() {
        return {
            // ---------- contract ----------------------

            contractID: null,
            contractNumber: null,
            selectedContractID: -1,
            selectedContractNumber: null,
            contractList: null,
            defaultContract: { contractId: -1, contractNumber: 'Please Select a Value' },
            previousContractNumberForVerification: null,

            // ---------- Hide/Show Flags ----------------------

            showConfirmation: false,
            showInstrutions: false,
            showSelGrid: true,
            showConfirmSelectedNames: false,

            // ---------- Buttons ----------------------

            disableSubmit: false,

            // ---------- Other ----------------------

            confirmedNumberTransferred: null,
            numberOfSelectedPeople: 0,

            // ---------- grid ----------------------
            
            gridTime: { grid: null, time: null },
            selectedPeopleArray: new Array(),
            selectedPeopleNamesArray: new Array(),
            rowsPerPageArray: [5, 10, 25, 50, 100, 250],
            headerArrays: [
                { defaultShow: true, rawName: 'personID', displayName: 'Person ID', hoverText: 'Database Primary key for the person' },
                { defaultShow: true, rawName: 'name', displayName: 'Name', hoverText: 'Last Name, First Name' },
                { defaultShow: false, rawName: 'selectedForTransfer', displayName: 'Selected', hoverText: 'true if selected for transfer' },
            ],

            //leftHeader0,   ..., leftHeader9
            //rightHeader10, ..., rightHeader19
            leftRightSlots: [
            { slot: 'rightHeader10', enableSorting: true, field: 'selectedForTransfer'},
            ],

            // ------------------ modal ---------------------

            modalTitle: null,

        };
    },

    created() {
        // console.log('**** MultiPersonTransfer.vue(): created ****');
        this.setContractDetails();
        this.GetContractForUserRoleWithArchive();
        this.getPeopleForTransfer();
    },

    mounted () {
        this.setSubmitDisableValue ();

    },
    computed: {
        UserProfileId() {
        return store.authenticatedUser.userProfileId != null
            ? store.authenticatedUser.userProfileId
            : store.tempUserProfileId;
        },
        UserEmail() {
        return store.authenticatedUser.email != null
            ? store.authenticatedUser.email
            : store.tempUserEmail;
        }
    },

    components: { ApplicationGrid },

    methods: {

        // --------------------- Grid Strt ----------------------

        getPeopleForTransfer() {

        axios
            .get(store.webAPIUrl + "Person/SelectPeopleForTransfer/" + this.$data.contractID)
            .then((response) => response.data)
            .then((data) => {
            this.$data.gridTime = { grid: data, time: new Date().getTime() };
            });
        },

        // --------------------- Grid End -----------------------

        setContractDetails() {

            this.$data.contractID = this.$route.params.contractId;
            this.$data.contractNumber = this.$route.params.contractNumber;
            this.$data.previousContractNumberForVerification = this.$data.contractNumber;
            
            // this.logContractDetails();
        },

        logContractDetails() {
            console.log('this.$data.contractID = ', this.$data.contractID);
            console.log('this.$data.contractNumber = ', this.$data.contractNumber);
        },

        handleSelectAllPeople() {

            this.$data.numberOfSelectedPeople = 0;
            for (let i = 0; i < this.$data.gridTime.grid.length; i++) {
                this.$data.gridTime.grid[i]['selectedForTransfer'] = true;                
                this.$data.numberOfSelectedPeople = this.$data.numberOfSelectedPeople + 1;
            }

        },

        handleClearAllPeople() {
            for (let i = 0; i < this.$data.gridTime.grid.length; i++) {
                this.$data.gridTime.grid[i]['selectedForTransfer'] = false;                
            }
            this.$data.numberOfSelectedPeople = 0;
        },

        //This is called in response to clicking the Active/Inactive links.
        handleCheckboxClick(args) {

            let person_id = args.itemArg["personID"];
            // console.log('person_id = ', person_id);

            let ctrlID = '#checkBoxID_' + person_id;
            let ctrl = document.querySelector(ctrlID);

            this.updateGrid(person_id, ctrl);
        },

        updateGrid(person_id, checkboxCtrl) {

            let gridLength = this.$data.gridTime.grid.length;

            for (let i = 0; i < gridLength; i++) {
                if (this.$data.gridTime.grid[i]['personID'] == person_id) {

                    if (checkboxCtrl.checked) {
                        this.$data.numberOfSelectedPeople = this.$data.numberOfSelectedPeople + 1;
                        this.$data.gridTime.grid[i]['selectedForTransfer'] = true;
                    } else {
                        this.$data.numberOfSelectedPeople = this.$data.numberOfSelectedPeople - 1;
                        this.$data.gridTime.grid[i]['selectedForTransfer'] = false;
                    }

                    this.$data.gridTime.time = new Date().getTime();
                    break;
                } 
            }
            // console.log('this.$data.numberOfSelectedPeople = ', this.$data.numberOfSelectedPeople);

        },

        handleHideConfirmationClick() {
            this.$data.showConfirmation = !this.$data.showConfirmation;
            this.$data.confirmedNumberTransferred = null;
            // this.$data.previousContractNumberForVerification = null;
            this.$data.selectedContractNumber = null;
        },

        handleDatabaseTransferSubmitClick() {
            let modalWindow = document.querySelector("#xmodal-main-ID");
            modalWindow.style.display = "none";

            this.transferContract();
        },

        handleCancelTransferClick() {
            let modalWindow = document.querySelector("#xmodal-main-ID");
            modalWindow.style.display = "none";
        },

        handleTransferClick() {

            this.$data.modalTitle = 'Transfer Confirmation';

            let modalWindow = document.querySelector("#xmodal-main-ID");
            modalWindow.style.display = "block";

        },

        handleToggleInstructions() {
            this.$data.showInstrutions = !this.$data.showInstrutions;
        },

        handleToggleSelGrid() {
            this.$data.showSelGrid = !this.$data.showSelGrid;
        },

        handleToggleSelPeopleNames() {
            this.$data.showConfirmSelectedNames = !this.$data.showConfirmSelectedNames;
        },

        handleBackClick() {
            this.$router.push({ name: 'PersonsByContractMaster', params: { contractId: this.$data.contractID } });
        },

        setSubmitDisableValue () {

            let submitBtn = document.querySelector("#submitBtnID");

            if (this.$data.selectedContractID == -1) {
                submitBtn.disabled = true;
                this.$data.disableSubmit = true;
            } else if (this.$data.selectedContractID > -1) {
                submitBtn.disabled = false;
                this.$data.disableSubmit = false;
            }
        },

    // --------------------------------------------------------------------------
    // ---------------- GetContractForUserRoleWithArchive -----------------------
    // --------------------------------------------------------------------------

    GetContractForUserRoleWithArchive() {
        // console.log('this.UserProfileId = ', this.UserProfileId);

      axios
        .get(store.webAPIUrl + "Contract/getContractForUserRoleWithArchive/" + this.UserProfileId)
        .then((response) => response.data)
        .then((data) => {
          this.$data.contractList = data;

          //Add the default item to the top of the list.
          this.$data.contractList.unshift(this.$data.defaultContract);

          //Make the selection for the dropdown list.
          this.$data.selectedContractID = this.$data.defaultContract.contractId;
        });
    },

    // --------------------------------------------------------------------------
    // ---------------- transferContract ----------------------------------------
    // --------------------------------------------------------------------------

    transferContract() {
        // console.log('transferContract');
        this.getIndiciesOfThoseToBeTransferred();
        this.databaseTransfer();
    },

    databaseTransfer(){

        let formData = new FormData();
        formData.append("UserProfileID",this.UserProfileId);
        formData.append("People",this.$data.selectedPeopleArray);
        formData.append("ContractId",this.$data.selectedContractID);
        formData.append("UserEmail",this.UserEmail);

        axios
        .post(store.webAPIUrl + "Contract/MultiTransferPersonContract/",formData)
        .then((response) => response.data)
        .then((data) => {
            this.removePeopleTransferedFromGrid();
            this.getSelectedContractNumber();
            this.$data.confirmedNumberTransferred = data;
            this.$data.showConfirmation = true;
            this.$data.showConfirmSelectedNames = false;

            this.clearPageOfPreviousTransfer();
        });
    },

    clearPageOfPreviousTransfer(){
        this.$data.numberOfSelectedPeople = 0;
        this.$data.disableSubmit = true;
        this.$data.selectedContractID = this.$data.defaultContract.contractId;
    },

    getSelectedContractNumber() {
        // selectedContractNumber

        for (let i = 0; i < this.$data.contractList.length; i++){
            if (this.$data.contractList[i]["contractId"] == this.$data.selectedContractID){
                this.$data.selectedContractNumber = this.$data.contractList[i]["contractNumber"];
                break;
            }
        }
        // console.log('this.$data.selectedContractNumber = ', this.$data.selectedContractNumber);
    },

    removePeopleTransferedFromGrid(){

        // Remove the transfered people from the data grid.
        // Note reverse order which prevents elements yet to be removed
        // from having their indices changed.
        for (let i = this.$data.selectedPeopleArray.length - 1; i >= 0; i--) {

            for (let j = 0; j < this.$data.gridTime.grid.length; j++){
                if (this.$data.gridTime.grid[j]["personID"] == this.$data.selectedPeopleArray[i]) {
                    this.$data.gridTime.grid.splice(j,1);
                    break;
                }
            }
        }
    },

    //Get the grid indicicies of those records corresponding to
    //people selected from transfer.
    getIndiciesOfThoseToBeTransferred() {

        this.$data.selectedPeopleArray = new Array();
        this.$data.selectedPeopleNamesArray = new Array();

        let gridLength = this.$data.gridTime.grid.length;
        for (let i = 0; i < gridLength; i++) {
            if (this.$data.gridTime.grid[i]['selectedForTransfer'] == true){

                this.$data.selectedPeopleArray.push(
                    this.$data.gridTime.grid[i]['personID']
                );

                this.$data.selectedPeopleNamesArray.push(
                    this.$data.gridTime.grid[i]['name']
                );
            }
        }

    },

    },
};

</script>
  
<style scoped>

/* ------------------- card ------------------------- */

.cardNew {
  width: 100%;
  border: 1px solid black;
}

/* .cardNew {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 30px -20px, rgba(0, 0, 0, 0.3) 0px 30px 15px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
  width: 100%;
  border: 1px solid lightgrey;
} */


/* -------------------- containers ------------------------- */

.cardUpperMargin {
  margin-top: 0px;
}

/* display: grid; */

.contentDiv {

 display: grid;

 justify-content: center;
 align-items: center;

 width: 100%;
 padding: 0px;

 /* background-color: lightcoral; */
 /* border: 1px solid blue; */
}

/* -------------------- margin padding align ------------------------- */

.transferDiv {
  margin-left: 20px;
  display: inline-block;
}

.instructionsLeft {
  text-align: left;
  margin: auto;
}

.cardSeparation {
    margin-top: 40px;
}

.leftJustify {
  text-align: left;
  margin: auto;
}

.divMainPadding {
    padding: 10px;
}

.divContentPadding {
    padding-left: 15px;
    padding-right: 15px;
}

.liStyle {
  margin-left: 10px;
  text-align: left;
}

/* -------------------- buttons ------------------------- */

.allButtons {
  font-size: 14px; 
  padding-top: 5px; 
  padding-bottom: 5px; 
  padding-left: 15px; 
  padding-right: 15px; 
}

.allButtonsDisabled {
  border-radius: 6px;
  font-size: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: default;
  color: white;
  background-color: #3e79a8;
}

.selectCursor {
    cursor: pointer;
}

.expandContractPlus {
  margin-right: 5px;
  font-weight: bold;
  font-size: 18px;
  color: darkred;
}

.expandContractMinus {
  margin-right: 5px;
  font-weight: bold;
  font-size: 24px;
  color: darkred;
}

.ctrlBorderRadius {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}

.ctrlDropDown {
  height: 30px;
  padding: 5px;
}

.ctrlDropDownMargin {
  margin-left: 10px;
}
/* -------------------------------------------------------------- */
/* ------------------- start modal style ------------------------ */
/* -------------------------------------------------------------- */

option:first-of-type {
  color: blue;
}

/* ---------- containers ---------- */

.xmodal-container-main {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  padding-top: 50px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

.xmodal-container-form {
  margin: 5px;
  display: grid;
  grid-template-columns: 100%;
  align-items: center;
  justify-content: center;

  /* background-color: lightyellow; */
}

.xmodal-container-content {
  background-color: #fefefe;
  margin: auto;

  padding: 20px;
  border: 1px inset black;

  width: 700px;
  height: 225px;
  margin-bottom: 250px;
  overflow-x: auto;
}

/* ---------- header and footer ---------- */

.xmodal-footer {
  text-align: center;
}


</style>